import {api} from '../../../../configs/index';
import {getUrl} from "../../../../services/helper";
import {baseAxios} from "../../../../services/api";
import {setIsLoading, setTableLoading} from "../loading/actions";
import {
    SET_PROPOSAL_LIST,
    SET_PROPOSAL_LIST_META,
    SET_PROPOSAL_LIST_FILTER_DATA,
    SET_PROPOSAL_LIST_BY_DATE,
    SET_PROPOSAL_LIST_BY_HOUR,
} from "./types";

export const setProposalList = payload => async dispatch => dispatch({type: SET_PROPOSAL_LIST, payload})
export const setProposalListMeta = payload => async dispatch => dispatch({type: SET_PROPOSAL_LIST_META, payload})
export const setProposalListByDate = payload => async dispatch => dispatch({type: SET_PROPOSAL_LIST_BY_DATE, payload})
export const setProposalListByHour = payload => async dispatch => dispatch({type: SET_PROPOSAL_LIST_BY_HOUR, payload})
export const setProposalListFilterData = payload => async dispatch => dispatch({
    type: SET_PROPOSAL_LIST_FILTER_DATA,
    payload
})

export const getProposalList = ({
                                    paginationParams = {
                                        per_page: 25,
                                        page: 1,
                                        order: {
                                            field: null,
                                            sort: 'asc'
                                        }
                                    },
                                    filterFormData = {},
                                }) => async dispatch => {

    dispatch(setTableLoading(true))

    try {
        console.log('api.leads.proposalList');
        const {data} = await baseAxios()
            .get(getUrl(api.leads.proposalList), {
                params: {...paginationParams, ...filterFormData}
            })
        dispatch(setProposalList(data.items))
        dispatch(setProposalListMeta(data.meta))
        dispatch(setProposalListByDate(data.proposalsByDate))
        dispatch(setProposalListByHour(data.proposalsByHour))
        dispatch(setProposalListFilterData(data.filters))
    } catch (e) {
        console.error(e)
    } finally {
        dispatch(setTableLoading(false))
    }
}
